import { useQuery } from '@apollo/client'

import {
  JoorPayOrdersDocument,
  JoorPayOrdersQuery,
  OrderFilterInput,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
query JoorPayOrders($filters: OrderFilterInput!, $offset:Int, $limit: Int) {
  orders(filters: $filters, offset: $offset, limit: $limit) {
    edges {
      node {
        id
        created
        event {
          id
          name
          code
        }
        collections {
          edges {
            node {
              id
              name
            }
          }
        }
        brand {
          id
          name
        }
        retailerProfile {
          id
          displayName
        }
        referenceNumber
        priceType {
          id
          currency {
            id
            code
          }
        }
        status
        trackingNumber
        salesRepresentative {
          id
          displayName
        }
        webOrderLookupId
        shipping {
          deliveryWindow {
            startDate
            completeDate
          }
          address {
            email
          }
        }
        billing {
          address {
            firstAddress
            secondAddress
            country
            city
            zip
          }
        }
        financials {
          dueTotal {
            maxPrice
          }
          wholesaleTotal {
            maxPrice
          }
          subTotal {
            maxPrice
          }
          orderDiscount {
            factor
          }
          shippingFees {
            factor
          }
          tax {
            factor
          }
          customFees {
            id
            factor
          }
          totalUnits 
        }
        paymentInfo {
          paymentStatus
          requestStatus
          firstRequest
          lastNotifiedDate
          lastTransaction
          paidAmount
          remainingBalance
          dueDate
        }
        paymentMethod {
          id
          name
        }
      }
    }
    totalCount
  }
}
`

const PAGE_SIZE = 25

export const usePayOrdersQuery = ({
  filters,
  skip,
}: {
  filters: OrderFilterInput
  skip?: boolean
}) => {
  const { data, loading, error, fetchMore } = useQuery<JoorPayOrdersQuery>(
    JoorPayOrdersDocument,
    {
      client: atlasClient,
      variables: {
        filters,
        offset: 0,
        limit: PAGE_SIZE,
      },
      skip,
      fetchPolicy: 'cache-first',
    },
  )

  return {
    data,
    fetchMore,
    loading,
    error,
  }
}
